import React, {Fragment, FunctionComponent} from "react";
import {Step} from "../WizardMap";
import Slide from "./animation/Slide";
import Fade from "./animation/Fade";
import {Redirect, Route, Switch} from "react-router-dom";
import * as H from "history";
import {Direction, invertDirection, useNavigation} from "./navigationHook";

const SlideRouter: FunctionComponent<{ initialStep: Step }> = ({initialStep}) => (
        <Switch>
            <Route exact path="/" render={({location}) =>
                <Redirect to={!location.search ? `/${initialStep}?gl=DE` : `/${initialStep}${location.search}`}/>
            }/>
            <Route exact path="*" render={({history}) => (
                <PathStackSlider
                    initialStep={initialStep}
                    history={history}
                />)
            }/>
        </Switch>
);

type PathStackSliderProps = {
    initialStep: Step,
    history: H.History;
};

const PathStackSlider: FunctionComponent<PathStackSliderProps> = ({initialStep, history}) => {

    const {navState, renderStep} = useNavigation(history, initialStep);

    return (
        <Fragment>
            {navState.leavingSlide &&
            <Slide
                key={navState.leavingSlide.step}
                timeout={400}
                animationIn={false}
                direction={navState.leavingSlide.direction}
            >
                <Fade fadeTime={0.5}>
                    {navState.leavingSlide.step && renderStep(navState.leavingSlide.step)}
                </Fade>
            </Slide>}
            <Slide
                key={navState.curSlide ? navState.curSlide.step : ""}
                timeout={800}
                animationIn={true}
                direction={navState.leavingSlide ? invertDirection(navState.leavingSlide.direction) : Direction.LEFT}
            >
                {navState.curSlide && renderStep(navState.curSlide.step)}
            </Slide>
        </Fragment>
    );
};

export default SlideRouter;
